import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Table } from 'primeng/table';
import {
  PaymentScheduleTabName,
  ProgramTypesGUID,
  ProgramTypes,
  EventDocumentTypeIds
} from '../../../models/_enum-collections';
import {
  EventPaymentBatchList,
  EventPaymentBatchExportToCsv
} from '../../../models/event-payment-batch-list.model';
import { AppConstants } from '../../common/app-constants';
import { SettingsService } from '../../common/settings.service';
import { EventPaymentScheduleService } from '../../services/event-payment-schedule.service';
import { ExportService } from '../../services/export.service';
import { CommonSharedModule } from '../../common/shared.module';
import engagementPaymentScheduleConfig from './event-payment-schedule-config.json';

@Component({
  selector: 'app-event-payment-schedule',
  templateUrl: './event-payment-schedule.component.html',
  styleUrls: ['./event-payment-schedule.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventPaymentScheduleComponent implements OnInit, OnChanges {
  @Input() selectedProgramOption!: string;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  isSpin = false;

  @ViewChild('dt', { static: false }) dt!: Table;
  @Input() currentTabname!: PaymentScheduleTabName;

  eventPaymentBatchList: EventPaymentBatchList[] = [];
  eventPaymentBatchExport: EventPaymentBatchExportToCsv[] = [];
  pscols!: any[];
  csvHeaders!: any[];
  exportFileName!: string;
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  datePipe = new DatePipe('en-US');
  isM1 = true;
  isM2 = false;
  programTypeGuid: string = ProgramTypesGUID.Events;
  eventRegistrationIds!: string;
  noOfEvents!: string;

  constructor(
    public settings: SettingsService,
    private epmService: EventPaymentScheduleService,
    private exportService: ExportService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loading = true;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.getEventSheduleHeaderFilelds();
    this.pscols = [
      { field: 'paymentBatchName', header: 'Payment Batch Name' },
      {
        field: 'paymentBatchScheduleDate',
        header: 'Payment Batch Schedule Date'
      },
      { field: 'paymentBatchStatus', header: 'Payment Batch Status' },
      {
        field: 'actualPaymentCentralDate',
        header: 'Actual Payment Central Date'
      },
      { field: 'totalAmount', header: 'Total Amount' },
      { field: 'eventRegistrationIds', header: this.eventRegistrationIds },
      { field: 'noOfEvents', header: this.noOfEvents },
      { field: 'partnersIds', header: 'Partners Paid' }
    ];

    this.getAllPaymentBatch();
  }

  getAllPaymentBatch() {
    if (this.currentTabname === PaymentScheduleTabName.Milestone1) {
      this.getMilestone1PaymentBatch();
      this.isM1 = true;
      this.isM2 = false;
    } else if (this.currentTabname === PaymentScheduleTabName.Milestone2) {
      this.getMilestone2PaymentBatch();
      this.isM1 = false;
      this.isM2 = true;
    }
  }
  getMilestone2PaymentBatch() {
    this.loading = true;
    this.getEventSheduleHeaderFilelds();
    this.epmService
      .getAllM2EventPaymentBatch(this.programTypeGuid)
      .subscribe(epbList => {
        if (
          epbList === null ||
          epbList.length === null ||
          epbList.length === 0
        ) {
          this.eventPaymentBatchList = epbList;
          this.currentPageInfo = 'No Records Found';
          this.loading = false;
        } else {
          this.eventPaymentBatchList = epbList;
          this.totalRecords = this.eventPaymentBatchList.length;
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
          this.loading = false;
        }
      });
  }

  getMilestone1PaymentBatch() {
    this.loading = true;
    this.getEventSheduleHeaderFilelds();
    this.epmService.getAllEventPaymentBatch().subscribe(epbList => {
      if (epbList === null || epbList.length === null || epbList.length === 0) {
        this.loading = false;
      } else {
        if (this.selectedProgramOption == 'MRPP') {
          this.eventPaymentBatchList = epbList.filter(
            obj =>
              obj.programTypeId === ProgramTypes.MRPP &&
              obj.eventTypeId !==
                EventDocumentTypeIds.DealAssociationTemplate &&
              obj.eventTypeId !==
                EventDocumentTypeIds.DealAssociationTemplateRFP
          );
        } else if (this.selectedProgramOption == 'Events') {
          this.eventPaymentBatchList = epbList.filter(
            obj => obj.programTypeId === ProgramTypes.Events
          );
        }
        this.totalRecords = this.eventPaymentBatchList.length;

        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        this.totalRecords === 0
          ? (this.currentPageInfo = 'No Records Found')
          : this.currentPageInfo;
        this.loading = false;
        if (this.totalRecords < this.dataViewRecsPerPage) {
          this.currentPageInfo =
            'Showing 1' +
            ' - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'paymentBatchName';
      this.dt.sortOrder = -1;
      this.dt.reset();
    }

    if (
      this.eventPaymentBatchList === null ||
      this.eventPaymentBatchList.length === 0
    ) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.totalRecords = this.eventPaymentBatchList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }

  editPaymentBatchDetails(paymentBatchName: string) {
    const navigationExtras: NavigationExtras = {
      state: {
        selectedProgramOption: this.selectedProgramOption,
        programTypeGuid: this.getProgramTypeGuid()
      }
    };
    if (this.currentTabname === PaymentScheduleTabName.Milestone1) {
      this.router.navigate(
        ['/events-edit-payment-batch', paymentBatchName],
        navigationExtras
      );
    } else if (this.currentTabname === PaymentScheduleTabName.Milestone2) {
      this.router.navigate(
        ['/event-edit-payment-batch-milestone2', paymentBatchName],
        navigationExtras
      );
    }
  }

  exportToCSV() {
    this.eventPaymentBatchExport = [];
    this.getCsvHeaders();
    this.getCsvFileName();
    this.eventPaymentBatchList.forEach(data => {
      this.eventPaymentBatchExport.push({
        PaymentBatchName: data.paymentBatchName,
        PaymentBatchScheduleDate:
          this.datePipe.transform(
            data.paymentBatchScheduleDate,
            'MM/dd/yyyy'
          ) || '',
        AnticipatedPaymentDate:
          this.datePipe.transform(data.anticipatedPaymentDate, 'MM/dd/yyyy') ||
          '',
        ActualPaymentCentralDate:
          this.datePipe.transform(
            data.actualPaymentCentralDate,
            'MM/dd/yyyy'
          ) || '',
        TotalAmount: data.totalAmount,
        EventIds: data.eventRegistrationIds,
        NoOfEvents: data.noOfEvents,
        PartnersPaid: data.partnersIds
      });
    });

    this.exportService.eventsExportToCsv(
      this.eventPaymentBatchExport,
      this.exportFileName,
      this.csvHeaders
    );
  }

  createNewPaymentBatch() {
    let navigationExtras: NavigationExtras;
    localStorage.setItem('programTypeGuid', this.getProgramTypeGuid());
    if (this.currentTabname === PaymentScheduleTabName.Milestone1) {
      navigationExtras = {
        state: {
          selectedProgramOption: this.selectedProgramOption,
          programTypeGuid: this.getProgramTypeGuid()
        }
      };
      this.router.navigate(['/events-new-payment-batch'], navigationExtras);
    } else if (this.currentTabname === PaymentScheduleTabName.Milestone2) {
      navigationExtras = {
        state: {
          programTypeGuid: this.getProgramTypeGuid()
        }
      };
      this.router.navigate(
        ['/event-new-payment-batch-milestone2'],
        navigationExtras
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedProgramOption']) {
      this.getAllPaymentBatch();
    }
  }

  getEventSheduleHeaderFilelds() {
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = engagementPaymentScheduleConfig.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );
    this.eventRegistrationIds =
      programTypeConfig?.element.find(
        obj => obj.id === 'engagementRegistrationIds'
      )?.displayName || '';
    this.noOfEvents =
      programTypeConfig?.element.find(obj => obj.id === 'noOfEngagement')
        ?.displayName || '';
  }

  getProgramTypeGuid() {
    return this.selectedProgramOption == 'MRPP'
      ? ProgramTypesGUID.MRPP
      : ProgramTypesGUID.Events;
  }

  getCsvHeaders() {
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = engagementPaymentScheduleConfig.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );
    this.csvHeaders = programTypeConfig?.exportHeaders || [];
  }

  getCsvFileName() {
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = engagementPaymentScheduleConfig.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );
    this.exportFileName =
      programTypeConfig?.fileName.find(obj => obj.id === this.currentTabname)
        ?.displayName || '';
  }
}
